import React from 'react';
import Seo from '../components/Seo';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';

const content = {
  termos: {
    eyebrow: 'Termos de uso',
    title: 'Termos e |Condições de Uso',
    subtitle: 'Última atualização: janeiro de 2026',
    path: '/termos',
    seoTitle: 'Termos de Uso',
    seoDescription: 'Termos e Condições de Uso da plataforma CoreDesk. Conheça os direitos e responsabilidades ao utilizar nossos serviços de atendimento com IA.',
    sections: [
      { h: '1. Aceitação dos termos', p: 'Ao acessar e utilizar a plataforma CoreDesk, você concorda em cumprir estes Termos de Uso. Caso não concorde com qualquer parte dos termos, você não deve utilizar o serviço.' },
      { h: '2. Descrição do serviço', p: 'A CoreDesk oferece uma plataforma SaaS de atendimento omnichannel com inteligência artificial, incluindo módulos de conversas, helpdesk e agentes de IA. O serviço é fornecido no formato de assinatura mensal ou anual.' },
      { h: '3. Contas e cadastro', p: 'Para utilizar a CoreDesk, você deve criar uma conta fornecendo informações verdadeiras, precisas e atualizadas. Você é responsável pela segurança das credenciais e por todas as atividades realizadas na sua conta.' },
      { h: '4. Uso aceitável', p: 'Você concorda em não utilizar o serviço para fins ilegais, spam, phishing, envio de conteúdo ofensivo ou qualquer atividade que viole leis brasileiras ou internacionais.' },
      { h: '5. Pagamento e cancelamento', p: 'As assinaturas são cobradas conforme o plano escolhido. Você pode cancelar a qualquer momento, com efeito ao final do ciclo de faturamento atual. Não oferecemos reembolso de períodos parciais.' },
      { h: '6. Propriedade intelectual', p: 'Todo o conteúdo, marca e código da plataforma CoreDesk são de propriedade exclusiva da empresa. Os dados inseridos por você permanecem sendo seus.' },
      { h: '7. Limitação de responsabilidade', p: 'A CoreDesk não se responsabiliza por danos indiretos, lucros cessantes ou perda de dados decorrentes do uso do serviço, exceto nos casos previstos em lei.' },
      { h: '8. Alterações dos termos', p: 'Podemos atualizar estes termos periodicamente. Alertaremos por e-mail sobre mudanças materiais com 30 dias de antecedência.' },
      { h: '9. Contato', p: 'Dúvidas sobre estes termos podem ser enviadas para juridico@coredesk.com.br.' },
    ],
  },
  privacidade: {
    eyebrow: 'Privacidade & LGPD',
    title: 'Política de |Privacidade',
    subtitle: 'Última atualização: janeiro de 2026',
    path: '/privacidade',
    seoTitle: 'Política de Privacidade',
    seoDescription: 'Política de Privacidade e LGPD da CoreDesk. Entenda quais dados coletamos, como usamos e quais são os seus direitos como titular.',
    sections: [
      { h: '1. Introdução', p: 'A CoreDesk leva sua privacidade a sério. Esta política descreve quais dados coletamos, como usamos e quais são seus direitos conforme a Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018).' },
      { h: '2. Dados coletados', p: 'Coletamos: (a) dados cadastrais (nome, e-mail, telefone, empresa); (b) dados de uso (logs, IP, dispositivo); (c) conteúdo processado na plataforma (mensagens, tickets), somente para viabilizar o serviço.' },
      { h: '3. Finalidade do tratamento', p: 'Usamos seus dados para: prover o serviço contratado, melhorar a plataforma, comunicar novidades relevantes, cumprir obrigações legais e proteger contra fraudes.' },
      { h: '4. Compartilhamento', p: 'Não vendemos seus dados. Compartilhamos apenas com processadores necessários (nuvem, pagamento, comunicação), todos com contratos que garantem proteção equivalente à nossa.' },
      { h: '5. Armazenamento e segurança', p: 'Dados são armazenados em servidores no Brasil, com criptografia em trânsito (TLS 1.3) e em repouso (AES-256). Auditoria de acessos e testes de segurança periódicos.' },
      { h: '6. Seus direitos (LGPD)', p: 'Você pode: acessar, corrigir, excluir, portar seus dados e revogar consentimento. Basta enviar um e-mail para dpo@coredesk.com.br. Respondemos em até 15 dias.' },
      { h: '7. Retenção', p: 'Mantemos os dados enquanto sua conta estiver ativa e por até 5 anos após o cancelamento, conforme obrigações fiscais. Você pode solicitar exclusão imediata a qualquer momento.' },
      { h: '8. Cookies', p: 'Utilizamos cookies essenciais e analíticos. Você pode gerenciar preferências no banner ao acessar o site.' },
      { h: '9. Encarregado (DPO)', p: 'Nosso encarregado de dados está disponível em dpo@coredesk.com.br para qualquer dúvida sobre privacidade.' },
    ],
  },
};

const Legal = ({ kind = 'termos' }) => {
  const c = content[kind];
  return (
    <>
      <Seo title={c.seoTitle} description={c.seoDescription} path={c.path} />
      <Header />
      <PageHero eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} />
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {c.sections.map((s, i) => (
            <div key={i}>
              <h2 className="text-xl md:text-2xl font-extrabold text-[#0a0e27]">{s.h}</h2>
              <p className="mt-3 text-slate-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Legal;
